var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 12.4222C8.20741 12.4222 8.38889 12.3444 8.54445 12.1889C8.7 12.0333 8.77778 11.8519 8.77778 11.6444C8.77778 11.437 8.7 11.2556 8.54445 11.1C8.38889 10.9444 8.20741 10.8667 8 10.8667C7.79259 10.8667 7.61111 10.9444 7.45556 11.1C7.3 11.2556 7.22222 11.437 7.22222 11.6444C7.22222 11.8519 7.3 12.0333 7.45556 12.1889C7.61111 12.3444 7.79259 12.4222 8 12.4222ZM7.33333 9.22222H8.66667V3.37778H7.33333V9.22222ZM4.66667 16L0 11.3333V4.66667L4.66667 0H11.3333L16 4.66667V11.3333L11.3333 16H4.66667ZM5.22222 14.6667H10.7778L14.6667 10.7778V5.22222L10.7778 1.33333H5.22222L1.33333 5.22222V10.7778L5.22222 14.6667Z",
    fill: "#A5A4BF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/error_icon.5e3e77a6ee36a36ad28b581ce53a91ea.svg";
export { ForwardRef as ReactComponent };